import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { _isNotBlank } from '@/littledash';

interface SelectProps {
  name: string;
  isMulti: boolean;
}

const Select: FC<SelectProps> = ({ name, isMulti }) => {
  const { control } = useFormContext();

  const formatValue = (value: string | Array<string>) => {
    if (Array.isArray(value)) {
      return value.join(', ');
    } else if (_isNotBlank(value)) {
      if (isMulti) {
        return JSON.parse(value).join(', ');
      }
      return value;
    } else {
      return '-';
    }
  };

  return (
    <Controller name={name} control={control} render={({ field: { value } }) => <span>{formatValue(value)}</span>} />
  );
};

export default Select;
